import { ReactElement, ChangeEvent, useMemo, useCallback } from 'react';
import { FormControlLabel } from '@mui/material';
import { useFormikContext } from 'formik';
import classNames from 'classnames';

import {
  SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME,
  getScheduleRouteBaseFormInititalValues,
} from '../../../utils/scheduleRouteForm';

import { AssistantGenerateRoutesDialogScheduleRouteCardProps } from '../types';

import { AssistantGenerateRoutesDialogScheduleRouteCardTitleSwitch } from './styles';

const AssistantGenerateRoutesDialogScheduleRouteCardTitle = ({
  onEnabled,
  isExpandedCard,
}: Pick<AssistantGenerateRoutesDialogScheduleRouteCardProps, 'onEnabled'> & {
  isExpandedCard: boolean;
}): ReactElement => {
  const { values, setValues, validateForm, getFieldProps } =
    useFormikContext<
      ReturnType<typeof getScheduleRouteBaseFormInititalValues>
    >();

  const isEnabled = useMemo(
    () => values[SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED],
    [values],
  );

  const handleChangeEnabled = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target;

      setValues(
        {
          ...values,
          ...getScheduleRouteBaseFormInititalValues(),
          [SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED]:
            checked,
        },
        false,
      );

      onEnabled(checked);

      await validateForm();
    },
    [onEnabled, values, setValues, validateForm],
  );

  return (
    <FormControlLabel
      label="PROGRAMAR RUTA"
      componentsProps={{
        typography: {
          variant: 'subtitle2',
          fontWeight: 'bold',
        },
      }}
      control={
        <AssistantGenerateRoutesDialogScheduleRouteCardTitleSwitch
          {...getFieldProps(
            SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED,
          )}
          checked={isEnabled}
          onChange={handleChangeEnabled}
          size="small"
          className={classNames({ pulse: isExpandedCard && !isEnabled })}
        />
      }
      sx={{ marginLeft: -0.5 }}
    />
  );
};

export default AssistantGenerateRoutesDialogScheduleRouteCardTitle;
